import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "../i18n";
import api from "../lib/api";
import { inr, ddmmyyyy } from "../lib/format";
import { SectionTitle, Pill, EmptyState, PrimaryButton } from "../components/common";
import { FileText, Plus, ArrowRight } from "lucide-react";

export default function Agreements() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/agreements").then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <SectionTitle>{t("agreement")}</SectionTitle>
        <button onClick={() => navigate("/agreements/new")} data-testid="new-agreement-btn" className="flex items-center gap-1 text-sm font-semibold text-terracotta bg-terracotta-light px-3 py-1.5 rounded-full"><Plus className="w-4 h-4" /> {t("gen_agreement")}</button>
      </div>
      {items.length === 0 ? <EmptyState icon={FileText} title={t("agreement")} sub={t("gen_agreement")} /> : (
        <div className="space-y-2.5">
          {items.map((a) => (
            <button key={a.id} onClick={() => navigate(`/agreements/${a.id}`)} data-testid={`agreement-${a.id}`} className="gs-card p-4 w-full text-left active:scale-[0.99]">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2"><FileText className="w-5 h-5 text-terracotta" /><span className="font-head font-semibold text-slate-800">{a.property_address}</span></div>
                <Pill tone={{ active: "trust", draft: "amber" }[a.status] || "slate"}>{a.status}</Pill>
              </div>
              <div className="flex items-center justify-between mt-2 text-sm text-slate-500">
                <span>{inr(a.rent)}{t("per_month")} · {a.tenancy_months}m</span>
                <ArrowRight className="w-4 h-4 text-slate-300" />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
